module.exports = __webpack_public_path__ + "img/values-img-1.1b30f59a.svg";